module.exports = {"511002001":"城东街道","511002002":"城南街道","511002003":"城西街道","511002004":"玉溪街道","511002005":"牌楼街道","511002007":"乐贤街道","511002100":"白马镇","511002101":"史家镇","511002102":"凌家镇","511002103":"朝阳镇","511002104":"永安镇","511002105":"全安镇","511002106":"靖民镇","511002108":"龚家镇","511002109":"凤鸣镇","511002110":"伏龙镇","511002111":"龙门镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511002.json
// module id = 2322
// module chunks = 0